export const ageOptions = ['18-33', '34-49', '50 and above', 'No preference'];

export const sexOptions = ['Male', 'Female', 'No Preference'];

export const exAbroadOptions = ['Yes', 'No Preference'];
export const withChildrenOptions = ['Yes', 'No Preference'];

export const civilStatusOptions = [
  'Single',
  'Married',
  'Separated',
  'Widower',
  'Divorced',
  'No Preference',
];

export interface PutAdvanceSearchFilters {
  role: string;
  ageFilter: string;
  sexFilter: string;
  exAbroad: boolean | null;
  civilStatus: string;
  withChildren: boolean | null;
  selectedSkills: string[];
}

export interface PutAdvanceSearchFilterBody {
  roleFilters: {
    kazamRoleId: string;
    ageFilter: string;
    sexFilter: string;
    exAbroad: boolean;
    civilStatus: string;
    skills: string[];
    withChildrenFilter: boolean;
  }[];
}

export interface PutAdvanceSearchFilterBodyV2 {
  ageFilter: string;
  sexFilter: string;
  civilStatus: string;
  withChildrenFilter: boolean;
}